<template>
  <div class="index-image" v-if="index.image">
    <img
      class="fade"
      v-lazy="{ src: index.image, error: lightErrorImage }"
    />
  </div>

  <div v-else class="index-image">
    <icon :name="index.icon || 'account_circle'" />
  </div>
</template>

<script>
import Icon from './Icon';

import lightErrorImage from '../images/empty-card-light.png';

export default {
  components: {
    Icon,
  },

  props: {
    index: [String, Object],
  },

  data() {
    return {
      lightErrorImage,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.index-image {
  width: var(--index-image-size, 58px);
  height: var(--index-image-size, 58px);
  min-width: var(--index-image-size, 58px);
  min-height: var(--index-image-size, 58px);
  background-color: var(--theme-highlight);
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  --icon-size: calc(var(--index-image-size, 58px) * .5);
}

img {
  object-fit: cover;
  height: 100%;
  width: 100%;
}
</style>
